export interface VersionSetOption {
  value: string;
  label: string;
  description: string;
  // Present (and true) only on options that should appear exclusively in the alpha deployment.
  alphaOnly?: boolean;
}

export const VERSION_SET_OPTIONS = [
  {
    value: 'AWSDevDocsAlpha/alpha',
    label: 'Alpha',
    description: 'AWSDevDocsAlpha/alpha',
  },
  {
    value: 'AWSDevDocsInteg/integ',
    label: 'Integ',
    description: 'AWSDevDocsInteg/integ',
  },
  {
    value: 'AWSDevDocs/public',
    label: 'Public',
    description: 'AWSDevDocs/public',
  },
  // Test-only target: exercises the venue-build flow without touching a real docs version set.
  // Gated to the alpha deployment (see VenueList) and also rejected by the backend outside alpha.
  {
    value: 'AWSDevDocs/tlc-dummy-vs',
    label: 'Dummy VS (alpha test)',
    description: 'AWSDevDocs/tlc-dummy-vs',
    alphaOnly: true,
  },
] as const;

export type VersionSetValue = (typeof VERSION_SET_OPTIONS)[number]['value'];
